@if (data$ | async; as data) {
  <div class="container detailheader">
    <div class="row">
      <div class="col-10">
        <h5>{{ data.serialNumber }} ({{ data.terminalDomain }})</h5>
      </div>
      <div class="col-2 text-end">
        <button
          type="button"
          class="btn no-background p-0 text-dark"
          aria-label="Close"
          (click)="scrollIntoView($event)"
          (keydown.enter)="scrollIntoView($event)">
          <h4><i class="fa fa-exchange"></i></h4>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <h6>
          <multi-tz-date
            [date]="data.timestamp"
            [terminalTz]="data['extra-Timezone']"
            placement="bottom"></multi-tz-date>
        </h6>
      </div>
      <div class="d-flex col-4 text-end hoverOverflow">
        SEQ:&nbsp;{{ data.ingestSequence }}&nbsp;
        <app-terminal-events-jumper
          class="float-right"
          (clicked)="jumpTo($event)"
          [config]="{
            showAnyJumper: true,
            showTypeJumper: false,
            showBootJumper: false,
            showLabels: false,
            extraSmall: true,
          }"></app-terminal-events-jumper>
      </div>
      <div class="d-flex col-4 text-end hoverOverflow">
        SRC:&nbsp;{{ data.sourceName }}&nbsp;
        <app-terminal-events-jumper
          class="float-right"
          (clicked)="jumpTo($event)"
          [config]="{
            showAnyJumper: false,
            showTypeJumper: true,
            showBootJumper: false,
            showLabels: false,
            extraSmall: true,
          }"></app-terminal-events-jumper>
      </div>
    </div>
  </div>
}

<div class="container scrollable">
  @for (segment of combinedData$ | async; track segment) {
    <div>
      @if (segment.title.length) {
        <h5>{{ segment.title }}</h5>
      }
      @for (item of segment.data; track item) {
        <div class="no-overflow">
          @if (!filtered[item.key]) {
            <div class="row">
              <div class="col-3">
                {{ item.label ? item.label : item.key }}
              </div>
              <div class="col-7">
                {{ item.value }}
              </div>
              <div class="col-2">
                <!-- uncomment to re-introduce visible toggling -->
                <!-- <button type="button" class="btn btn-primary btn-sm selectbutton"
                btnCheckbox
                [ngClass]="item.selected ? 'active' : ''"
                (click)="toggleFilter($event, item)" (keydown.enter)="toggleFilter($event, item)">
                Select
              </button> -->
                @if (item.value) {
                  <button
                    type="button"
                    class="btn btn-primary-outline btn btn-transparant"
                    (click)="selectFilter($event, item)"
                    (keydown.enter)="selectFilter($event, item)">
                    <i class="fa fa-search"></i>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
      <hr class="transparent" />
    </div>
  }
</div>
